import {
    columnChartConfig,
    EChartDisplayType,
    renderChangeLabelsHof,
} from "pro-features/components/Chart/src/configs/column-chart/columnChartConfig";
import type { ColumnChartData } from "pro-features/components/Chart/src/types";
import { CHART_HEIGHT } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/const";
import { TooltipFormatter } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth/tooltipFormatter";
import { resolveMaxYaxisValue } from "pro-features/components/Chart/src/utils";
import { getCategoriesItems } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/getCategoriesItems";

const LABEL_PADDINGS = {
    ABSOLUTE: 32,
};

export const getChartConfig = (chartData: ColumnChartData = []) => {
    const mainSeries = chartData[0];
    if (!mainSeries) {return {};}
    const { data: mainSeriesData = [] } = mainSeries;
    const columnChartConfigArgs = {
        categories: getCategoriesItems(mainSeriesData),
        maxPointWidth: 20,
        height: CHART_HEIGHT,
        chartDisplayType: EChartDisplayType.ABSOLUTE,
        displayDataLabelsOnColumns: true,
        tooltipFormatter: TooltipFormatter,
        maxYaxisValue: resolveMaxYaxisValue(mainSeriesData),
        renderCustomLabels: renderChangeLabelsHof(LABEL_PADDINGS.ABSOLUTE),
    };
    return columnChartConfig(columnChartConfigArgs);
};
